

import React, { memo } from 'react';
import cx from 'classnames';
import SocialAuthButtonGoogle from './SocialAuthButtonGoogle';
import SocialAuthButtonApple from './SocialAuthButtonApple';
import { useSocialAuthButtonListContextValue } from '../context/useSocialAuthButtonListContextValue';

import { SocialAuthButtonListContext } from '../context/SocialAuthButtonListContext';


import '../styles/_social-auth-button-list.scss';












const SocialAuthButtonList = (
{
  loginSocial,
  alias,
  onSuccess,
  onError,
  className
}) =>

<div className={cx('social-auth-button-list', className)}>
    <SocialAuthButtonListContext.Provider value={useSocialAuthButtonListContextValue({
    loginSocial,
    alias,
    onSuccess,
    onError
  })}>

      <SocialAuthButtonGoogle />

      {/*
      Removed LinkedIn for now due to hard integration in the current flow
      <SocialAuthButtonLinkedIn />
      */}

      <SocialAuthButtonApple />

      {/*
      Removed Microsoft for now due to email is not required <SocialAuthButtonMicrosoft />
      https://xsreality.medium.com/making-azure-ad-oidc-compliant-5734b70c43ff
      */}
    </SocialAuthButtonListContext.Provider>
  </div>;



export default memo(SocialAuthButtonList);